export default "__VITE_ASSET__CoQj82FZ__"